// src/auth/bootstrapSession.js
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { graphRequest } from "../../authConfig";

async function fetchAllMemberOf(graphAccessToken) {
  let url =
    "https://graph.microsoft.com/v1.0/me/memberOf?$select=id,displayName";
  const all = [];

  while (url) {
    const res = await fetch(url, {
      headers: { Authorization: `Bearer ${graphAccessToken}` },
    });

    if (!res.ok) {
      const bodyText = await res.text();
      throw new Error(
        `Graph call failed (${res.status} ${res.statusText}): ${bodyText}`,
      );
    }

    const data = await res.json();
    all.push(...(data.value || []));
    url = data["@odata.nextLink"] || null;
  }

  return all
    .filter((x) => typeof x?.displayName === "string" && x.displayName.length)
    .map((x) => ({ id: x.id, displayName: x.displayName }));
}

export async function bootstrapSession({ instance }) {
  let account = instance.getActiveAccount();

  if (!account) {
    const accounts = instance.getAllAccounts() || [];
    if (accounts.length === 1) {
      account = accounts[0];
      instance.setActiveAccount(account);
    } else if (accounts.length > 1) {
      account = accounts[0];
      instance.setActiveAccount(account);
    }
  }

  if (!account) {
    return { ready: false };
  }

  const existingUser = sessionStorage.getItem("user");
  if (existingUser) {
    try {
      const parsedUser = JSON.parse(existingUser);
      if (parsedUser?.email === account.username) {
        return { ready: true };
      }
    } catch (e) {
      console.warn(
        "Invalid cached user in sessionStorage, rebuilding session.",
      );
    }
  }

  let tokenResp;
  try {
    tokenResp = await instance.acquireTokenSilent({
      ...graphRequest,
      account,
    });
  } catch (e) {
    if (e instanceof InteractionRequiredAuthError) {
      await instance.acquireTokenRedirect({
        ...graphRequest,
        account,
      });
      return { ready: false };
    }
    throw e;
  }

  const nameParts = (account.name || "").split(" ");
  const user = {
    firstName: nameParts[0] || account.username,
    lastName: nameParts.slice(1).join(" "),
    email: account.username,
  };
  sessionStorage.setItem("user", JSON.stringify(user));

  try {
    const groupObjects = await fetchAllMemberOf(tokenResp.accessToken);
    const groupNames = groupObjects.map((g) => g.displayName);
    sessionStorage.setItem("user_groups", JSON.stringify(groupNames));
    sessionStorage.setItem("user_groups_detail", JSON.stringify(groupObjects));
  } catch (err) {
    console.error("Graph groups fetch failed:", err);
    sessionStorage.setItem("user_groups", JSON.stringify([]));
    sessionStorage.setItem("user_groups_detail", JSON.stringify([]));
  }

  sessionStorage.setItem("mainNavIndex", 0);
  sessionStorage.setItem("subNavIndex", 0);

  return { ready: true };
}
